//import './foundation.js'
import "./vendors/sniff.min.js";
import "@/assets/sass/app.scss";
import Accessibility from "./accessibility";

// let acceptBtn = document.querySelector('.accept-cookie')
// if(acceptBtn) {
//     acceptBtn.addEventListener('click', (e) => {
//         e.preventDefault()
//         localStorage.setItem('accepted-terms', true)
//         document.querySelector('#cookie-message').classList.add('remove')
//     })
// }

// let closeBtn = document.querySelector('.close-cookie')
// if(acceptBtn) {
//     closeBtn.addEventListener('click', (e) => {
//         e.preventDefault()
//         document.querySelector('#cookie-message').classList.add('remove')
//     })
// }

// let accepted = localStorage.getItem('accepted-terms')
// if( !accepted ) {
//     document.querySelector('#cookie-message').classList.remove('remove')
// }

// Production steps of ECMA-262, Edition 5, 15.4.4.18
// Reference: http://es5.github.io/#x15.4.4.18
if (!Array.prototype.forEach) {
	Array.prototype.forEach = function (callback /*, thisArg*/) {
		var T, k;

		if (this == null) {
			throw new TypeError("this is null or not defined");
		}

		// 1. Let O be the result of calling toObject() passing the
		// |this| value as the argument.
		var O = Object(this);

		// 2. Let lenValue be the result of calling the Get() internal
		// method of O with the argument "length".
		// 3. Let len be toUint32(lenValue).
		var len = O.length >>> 0;

		// 4. If isCallable(callback) is false, throw a TypeError exception.
		// See: http://es5.github.com/#x9.11
		if (typeof callback !== "function") {
			throw new TypeError(callback + " is not a function");
		}

		// 5. If thisArg was supplied, let T be thisArg; else let
		// T be undefined.
		if (arguments.length > 1) {
			T = arguments[1];
		}

		// 6. Let k be 0.
		k = 0;

		// 7. Repeat while k < len.
		while (k < len) {
			var kValue;

			// a. Let Pk be ToString(k).
			//    This is implicit for LHS operands of the in operator.
			// b. Let kPresent be the result of calling the HasProperty
			//    internal method of O with argument Pk.
			//    This step can be combined with c.
			// c. If kPresent is true, then
			if (k in O) {
				// i. Let kValue be the result of calling the Get internal
				// method of O with argument Pk.
				kValue = O[k];

				// ii. Call the Call internal method of callback with T as
				// the this value and argument list containing kValue, k, and O.
				callback.call(T, kValue, k, O);
			}
			// d. Increase k by 1.
			k++;
		}
		// 8. return undefined.
	};
}

import "./components/_modal";
import "./components/_team";
import "./components/_portfolio";
import "./components/_updates";
import "./components/_social";
import "./components/_press";
import "./components/_media";
import "./components/_award";
import "./components/_office-map";

// Open and Close Menu
let menu = document.querySelector("[data-menu]");
if (menu) {
	menu.addEventListener("click", (e) => {
		e.preventDefault();
		document.body.classList.toggle("menu-open");
	});
}

import SmoothScroll from "smooth-scroll";
let scroll = new SmoothScroll('a[href*="#"]', {
	offset: 95,
});

import Flickity from "flickity";

if (jQuery(".block .carousel.content")[0]) {
	let carousel = new Flickity(".block .carousel.content", {
		cellAlign: "left",
		contain: true,
	});
}

if (jQuery(".block .carousel.content-text")[0]) {
	let carousel_text = new Flickity(".block .carousel.content-text", {
		cellAlign: "left",
		contain: true,
	});
}

if (jQuery(".single-community .carousel.content")[0]) {
	let community_carousel = new Flickity(
		".single-community .carousel.content",
		{
			cellAlign: "left",
			contain: true,
		}
	);
}

if (jQuery(".carousel.gallery")[0]) {
	let gallery = new Flickity(".carousel.gallery", {
		cellAlign: "left",
		imagesLoaded: true,
		autoPlay: true,
		cellSelector: ".carousel-cell",
		wrapAround: true,
	});
}

if (jQuery(".block .contained-carousel.content")[0]) {
	let contained_carousel = new Flickity(
		".block .contained-carousel.content",
		{
			cellAlign: "left",
			contain: true,
		}
	);
}

if (jQuery(".hero .gallery")[0]) {
	let hero_gallery = new Flickity(".hero .gallery", {
		cellAlign: "left",
		imagesLoaded: true,
		autoPlay: 4000,
		pauseAutoPlayOnHover: false,
		cellSelector: ".carousel-cell",
		wrapAround: true,
		pageDots: false,
		prevNextButtons: false,
	});
}

if (jQuery(".block .hero-carousel-background")[0]) {
	let hero_carousel = new Flickity(".block .hero-carousel-background", {
		cellAlign: "left",
		imagesLoaded: true,
		autoPlay: 4000,
		pauseAutoPlayOnHover: false,
		cellSelector: ".carousel-cell",
		wrapAround: true,
		pageDots: false,
		prevNextButtons: false,
	});
}

import Vue from "vue";

document.querySelectorAll(".tabs-view").forEach((tabs) => {
	new Vue({
		el: tabs,
		data() {
			return {
				active: 1,
			};
		},
		methods: {
			QueryParam(param) {
				let query = window.location.search.substring(1);
				let vars = query.split("&");
				for (var i = 0; i < vars.length; i++) {
					let pair = vars[i].split("=");
					if (pair[0] == param) {
						return unescape(pair[1]);
					}
				}
				return false;
			},
		},
		mounted() {
			let links = this.$el.querySelectorAll("nav a");
			if (links.length > 0 && links[0].getAttribute("data-id"))
				this.active = links[0].getAttribute("data-id");
			if (this.QueryParam("tab")) {
				let tab = document
					.querySelector(`[data-tab="${this.QueryParam("tab")}"]`)
					.getAttribute("data-id");
				if (tab) this.active = tab;
			}
		},
	});
});

/* if (jQuery("#list-1").length > 0 || jQuery("#list-2").length > 0) {
	setTimeout(() => {
		orderListByHeight("#list-1");
	}, 500);

	jQuery("#list-button-1").on("click", () => {
		setTimeout(() => {
			orderListByHeight("#list-1");
		}, 500);
	});
	jQuery("#list-button-2").on("click", () => {
		setTimeout(() => {
			orderListByHeight("#list-2");
		}, 500);
	});
}

function orderListByHeight(ulSelector) {
	var listItems = jQuery(ulSelector + " li")
		.toArray()
		.map(function (li) {
			var text = jQuery(li).text();
			console.log(jQuery(li).outerHeight() + " + " + text.length);
			return {
				element: li,
				height: jQuery(li).outerHeight(),
				characterCount: text.length,
			};
		});

	listItems.sort(function (a, b) {
		//		return a.length - b.length;
		return a.characterCount - b.characterCount;
	});

	jQuery(ulSelector).empty();

	jQuery.each(listItems, function (index, item) {
		jQuery(ulSelector).append(item.element);
	});
} */



// WEBPACK FOOTER //
// ./assets/js/app.js